import { render, staticRenderFns } from "./feeding_record.vue?vue&type=template&id=cdf52322&scoped=true&"
import script from "./feeding_record.vue?vue&type=script&lang=js&"
export * from "./feeding_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf52322",
  null
  
)

export default component.exports